import React, { Component } from 'react';
import { Form, Input, Select, Spin, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LinkInput } from 'components';
import { AlertActions, ProjectsActions } from 'redux/actions';
import pickBy from 'loadsh/pickBy';
import identity from 'loadsh/identity';
import isEmpty from 'loadsh/isEmpty';
import {
  Container,
  PrimaryButton,
  formLayout,
  formValidateMessages,
  H1,
  H2,
  FormWrapper,
  SpaceBetween,
  SecondaryButton,
  PrimaryButtonV2,
  AddFormItemLabel,
  AddSaveHint,
} from 'utils';
import RichText from './RichText';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled/macro';

const FormItem = Form.Item;

const AddTextArea = styled(Input.TextArea)`
  .ant-input {
    font-size: 16px;
    padding-top: 7px;
  }
`;

class BasicInformation extends Component {
  formRef = React.createRef();

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    isUniq: PropTypes.bool.isRequired,
    checkUrl: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleCreateProject: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
  };

  state = {
    link: 'test',
    creating: false,
  };

  onFinish = (values) => {
    const fundingValues = sessionStorage.getItem('fundingData');
    const fundingParsed = fundingValues ? JSON.parse(fundingValues) : {};
    sessionStorage.removeItem('fundingData');

    const categoryData = sessionStorage.getItem('categoryType');
    const categoryParsed = categoryData ? JSON.parse(categoryData) : {};
    sessionStorage.removeItem('categoryType');

    const userType = sessionStorage.getItem('userType');
    const userTypeParsed = userType ? JSON.parse(userType) : {};
    sessionStorage.removeItem('userType');

    const user = localStorage.getItem('user');
    if (!user) {
      console.error('Not logged in');
      return;
    }
    const parsedUser = JSON.parse(user);

    const vals = {
      ...values,
      url: `${values.url}`.toLowerCase(),
      ...fundingParsed,
      ...categoryParsed,
      ...userTypeParsed,
      initiator_email: parsedUser.email,
      initiator_first_name: parsedUser.first_name,
      initiator_last_name: parsedUser.last_name,
    };

    console.log('values: ', vals);
    const {
      updateDraft,
      projectId,
      currentStep,
      handleCreateProject,
      editProject,
    } = this.props;
    if (projectId) {
      updateDraft(projectId, vals, currentStep);
      if (editProject) this.props.handleSteps(3);
      else this.props.handleSteps(5);
      return;
    }
    this.setState({ creating: true });
    const error = handleCreateProject(vals);
    if (error) {
      this.setState({ creating: false });
      AlertActions.error(error, 'Fail');
    }
  };

  handleChangeLink = (e) => {
    this.setState({ link: e.target.defaultValue });
  };

  handleTitleChange = (e) => {
    const newTitle = e.target.value;
    const formattedLink = this.formatURL(newTitle);
    this.formRef.current?.setFieldsValue({
      url: formattedLink,
    });
  };

  formatURL = (title) => {
    return title
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .slice(0, 15);
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1]?.focus();
    }
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else {
      this.props.handleSteps(3);
    }
  };

  render() {
    const {
      project,
      loading,
      // isUniq,
      setCanMove,
      projectId,
      editProject,
    } = this.props;
    const { creating } = this.state;
    console.log(projectId, 'project--> ', project);
    return (
      <Container className="inside-form-container">
        <Spin spinning={projectId ? loading : creating}>
          <H1>Dein Projekt</H1>
          {projectId ? (
            !isEmpty(project) &&
            !loading && (
              <Form
                {...formLayout}
                ref={this.formRef}
                onChange={(e) => {
                  return setCanMove(false);
                }}
                name="project-details"
                onFinish={this.onFinish}
                validateMessages={formValidateMessages}
                initialValues={
                  project ? pickBy(project.basicInfo, identity) : {}
                }
              >
                <div>
                  <FormWrapper>
                    <>
                      <FormItem
                        name="title"
                        label={
                          <AddFormItemLabel>
                            Titel des projekts
                          </AddFormItemLabel>
                        }
                        required={false}
                        extra={
                          <div
                            style={{ paddingRight: 60, whiteSpace: 'normal' }}
                          >
                            Gib deinem Projekt einen aussagekräftigen Titel.
                          </div>
                        }
                        rules={[
                          {
                            required: true,
                            message: 'Titel ist erforderlich',
                          },
                        ]}
                      >
                        <AddTextArea
                          placeholder="Titel des Projekts"
                          rows={1}
                          showCount
                          maxLength={100}
                          style={{
                            height: '40px',
                            fontSize: '16px',
                            resize: 'none',
                          }}
                          onKeyDown={(event) => {
                            this.onKeyDown(event);
                          }}
                        />
                        {/* <Input maxLength={100}/> */}
                      </FormItem>
                      <FormItem
                        name="subtitle"
                        label={<AddFormItemLabel>Untertitel</AddFormItemLabel>}
                        required={false}
                        extra={
                          <div
                            style={{ paddingRight: 60, whiteSpace: 'normal' }}
                          >
                            Die Mission deines Projekts in einem Satz.
                          </div>
                        }
                        rules={[
                          {
                            required: true,
                            message: 'Untertitel ist erforderlich',
                          },
                        ]}
                      >
                        <AddTextArea
                          placeholder="Untertitel"
                          rows={1}
                          showCount
                          maxLength={100}
                          style={{
                            height: '40px',
                            fontSize: '16px',
                            resize: 'none',
                          }}
                          onKeyDown={(event) => {
                            this.onKeyDown(event);
                          }}
                        />
                      </FormItem>
                      {editProject ? (
                        <Tooltip
                          title="Falls du das ändern möchtest, wende dich an unser Support-Team."
                          placement="bottom"
                          color="#000"
                          overlayInnerStyle={{
                            color: '#fff',
                            borderRadius: '8px',
                          }}
                          arrow={true}
                        >
                          <FormItem
                            name="funding_days"
                            label={
                              <AddFormItemLabel>
                                Finanzierungszeitraum in Tagen
                              </AddFormItemLabel>
                            }
                            required={false}
                            extra="Maximal 90 Tage"
                            rules={[
                              {
                                required: true,
                                message:
                                  'Finanzierungszeitraum ist erforderlich',
                              },
                            ]}
                          >
                            <Input
                              placeholder="30 (empfohlen)"
                              type="number"
                              min={1}
                              max={90}
                              disabled={true}
                              style={{ height: '40px', fontSize: '16px' }}
                            />
                          </FormItem>
                        </Tooltip>
                      ) : (
                        <FormItem
                          name="funding_days"
                          label={
                            <AddFormItemLabel>
                              Finanzierungszeitraum in Tagen
                            </AddFormItemLabel>
                          }
                          required={false}
                          extra="Maximal 90 Tage"
                          rules={[
                            {
                              required: true,
                              message: 'Finanzierungszeitraum ist erforderlich',
                            },
                          ]}
                        >
                          <Input
                            placeholder="30 (empfohlen)"
                            type="number"
                            min={1}
                            max={90}
                            style={{
                              height: '40px',
                              fontSize: '16px',
                              resize: 'none',
                            }}
                            onKeyDown={(event) => {
                              this.onKeyDown(event);
                            }}
                          />
                        </FormItem>
                      )}

                      <H2>Erzähle uns deine Geschichte</H2>
                      <p>
                        Erkläre prägnant, worum es in deinem Projekt geht, warum
                        dein Vorhaben wichtig ist - und weshalb andere dich
                        unterstützen sollten.
                      </p>
                      <FormItem
                        name="description"
                        label={
                          <AddFormItemLabel>
                            Projektbeschreibung
                          </AddFormItemLabel>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: 'Bitte geben Sie eine Beschreibung ein.',
                          },
                        ]}
                        validateTrigger="onBlur"
                      >
                        <RichText
                          name="description"
                          getContent={this.getContent}
                          placeholder="Beschreibe dein Projekt..."
                        />
                      </FormItem>

                      <H2>Persönlicher Link zum Projekt</H2>
                      <p>
                        Du kannst einen persönlichen Link zum Projekt erstellen.
                        So wird das Teilen noch einfacher!
                      </p>

                      <LinkInput projectId={projectId} />
                    </>
                  </FormWrapper>
                </div>

                {editProject && <AddSaveHint />}

                <FormItem>
                  <SpaceBetween>
                    <SecondaryButton
                      type="button"
                      minWidth="120px"
                      onClick={this.onReturn}
                    >
                      {editProject ? (
                        <p>Zurück zur Projektübersicht</p>
                      ) : (
                        <>
                          <ArrowLeftOutlined />
                          <p>Zurück</p>
                        </>
                      )}
                    </SecondaryButton>

                    <PrimaryButtonV2
                      type="primary"
                      htmltype="submit"
                      minWidth="120px"
                      id="submit-button"
                    >
                      {editProject ? (
                        <p>Speichern*</p>
                      ) : (
                        <>
                          <p>Weiter</p>
                          <ArrowRightOutlined />
                        </>
                      )}
                    </PrimaryButtonV2>
                  </SpaceBetween>
                </FormItem>
              </Form>
            )
          ) : (
            <Form
              {...formLayout}
              ref={this.formRef}
              onChange={(e) => {
                return setCanMove(false);
              }}
              name="project-details"
              onFinish={this.onFinish}
              validateMessages={formValidateMessages}
              initialValues={''}
            >
              <div>
                <FormWrapper>
                  <>
                    <FormItem
                      name="title"
                      label={
                        <AddFormItemLabel>Titel des Projekts</AddFormItemLabel>
                      }
                      required={false}
                      extra={
                        <div style={{ paddingRight: 60, whiteSpace: 'normal' }}>
                          Gib deinem Projekt einen aussagekräftigen Titel.
                        </div>
                      }
                      rules={[
                        {
                          required: true,
                          message: 'Titel ist erforderlich',
                        },
                      ]}
                    >
                      <AddTextArea
                        placeholder="Titel des Projekts"
                        showCount
                        maxLength={100}
                        onChange={this.handleTitleChange}
                        style={{ height: '40px', resize: 'none' }}
                        onKeyDown={(event) => {
                          this.onKeyDown(event);
                        }}
                      />
                      {/* <Input maxLength={100}/> */}
                    </FormItem>
                    <FormItem
                      name="subtitle"
                      label={<AddFormItemLabel>Untertitel</AddFormItemLabel>}
                      required={false}
                      extra={
                        <div style={{ paddingRight: 60, whiteSpace: 'normal' }}>
                          Die Mission deines Projekts in einem Satz.
                        </div>
                      }
                      rules={[
                        {
                          required: true,
                          message: 'Untertitel ist erforderlich',
                        },
                      ]}
                    >
                      <AddTextArea
                        placeholder="Untertitel"
                        rows={1}
                        showCount
                        maxLength={100}
                        style={{
                          height: '40px',
                          fontSize: '16px',
                          resize: 'none',
                        }}
                        onKeyDown={(event) => {
                          this.onKeyDown(event);
                        }}
                      />
                    </FormItem>
                    <FormItem
                      name="funding_days"
                      label={
                        <AddFormItemLabel>
                          Finanzierungszeitraum in Tagen
                        </AddFormItemLabel>
                      }
                      extra="Maximal 90 Tage"
                      rules={[
                        {
                          required: true,
                          message: 'Finanzierungszeitraum ist erforderlich',
                        },
                      ]}
                      required={false}
                    >
                      <Input
                        placeholder="30 (empfohlen)"
                        type="number"
                        min={1}
                        max={90}
                        style={{
                          height: '40px',
                          fontSize: '16px',
                          resize: 'none',
                        }}
                        onKeyDown={(event) => {
                          this.onKeyDown(event);
                        }}
                      />
                    </FormItem>

                    <H2>Erzähle uns deine Geschichte</H2>
                    <p>
                      Erkläre prägnant, worum es in deinem Projekt geht, warum
                      dein Vorhaben wichtig ist - und weshalb andere dich
                      unterstützen sollten.
                    </p>

                    <FormItem
                      name="description"
                      label={
                        <AddFormItemLabel>Projektbeschreibung</AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'Bitte geben Sie eine Beschreibung ein.',
                        },
                      ]}
                      validateTrigger="onBlur"
                    >
                      <RichText
                        name="description"
                        getContent={this.getContent}
                        placeholder="Beschreibe dein Projekt..."
                      />
                    </FormItem>

                    <H2>Persönlicher Link zum Projekt</H2>
                    <p>
                      Du kannst einen persönlichen Link zum Projekt erstellen.
                      So wird das Teilen noch einfacher!
                    </p>

                    <LinkInput
                      projectId={projectId}
                      form={this.formRef.current}
                    />
                  </>
                </FormWrapper>
              </div>

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.onReturn}
                  >
                    <ArrowLeftOutlined />
                    <p>Zurück</p>
                  </SecondaryButton>

                  <PrimaryButtonV2
                    type="primary"
                    htmltype="submit"
                    minWidth="120px"
                    id="submit-button"
                  >
                    <p>Weiter</p>
                    <ArrowRightOutlined />
                  </PrimaryButtonV2>
                </SpaceBetween>
              </FormItem>
            </Form>
          )}
        </Spin>
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  const { currentStep, project, loading, errors, isUniq } = state.projects;
  return {
    currentStep,
    project,
    loading,
    errors,
    isUniq,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
  checkUrl: (url) => dispatch(ProjectsActions.checkUrl(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicInformation);
